// extracted by mini-css-extract-plugin
export default {"textWhite":"WhatAreMojoPoints_textWhite__i-V7f","textMain":"WhatAreMojoPoints_textMain__uPk8K","textBold":"WhatAreMojoPoints_textBold__JSclQ","list":"WhatAreMojoPoints_list__wKPX1"};